<template>
  <div class="spare_parts_detail">
    <a-descriptions bordered size="small" title="设备基本信息">
<!--      <a-descriptions-item label="物料描述" :span="2">{{ detail.xxx }}</a-descriptions-item>-->
      <a-descriptions-item label="设备名称">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="设备编号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="设备类别">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="规格型号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="设备状态">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="归口部门">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="使用部门">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="公司名称">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="WBS编号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="SAP设备编号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="SAP设备分类">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="图号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="使用人员">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions bordered size="small" title="设备来源信息">
      <a-descriptions-item label="制造商">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="供应商">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="购置价值">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="税率">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="购置净值">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="合同号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="采购订单编号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="入库单号">{{ detail.xxx }}</a-descriptions-item>
      <a-descriptions-item label="验收人">{{ detail.xxx }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: 'xxxxxx'
      }
    }
  },
  methods: {
    initDetail (model) {
      const params = {}
    }
  }
}
</script>

<style lang="less" scoped>
.spare_parts_detail{
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-descriptions{
    margin-bottom: -1px;
    .ant-descriptions-title{
      margin-bottom: 0;
      line-height: 32px;
      font-size: 12px;
      color: #08409F;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      padding: 0 12px;
      border-right: 1px solid #DDDDDD;
      // border-left: 1px solid #e8e8e8;
      background: #FFFFFF;
    }
    .ant-descriptions-view{
      border-radius: 0;
      width: 100%;
      border-color: #DDDDDD;
      // border-left: none;
      // border-right: none;
      .ant-descriptions-row{
        border-bottom: none;
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          padding: 8px 12px;
          height: 40px;
          border-bottom: 1px solid #DDDDDD;
          border-color: #DDDDDD;
        }
        .ant-descriptions-item-label{
          background: rgba(8,64,159,0.1);
          width: calc(100% / 9);
        }
        .ant-descriptions-item-content[colspan="1"]{
          // width: 230px;
          width: calc(100% / 9 * 2);
        }
        .ant-descriptions-item-content[colspan="3"]{
          // width: 580px;
          width: calc(100% / 9 * 5);
        }
        .ant-descriptions-item-content[colspan="5"]{
          // width: 930px;
          width: calc(100% / 9 * 8);
        }
      }
      .ant-descriptions-row:last-child{
        .ant-descriptions-item-label,
        .ant-descriptions-item-content{
          // border-bottom: none;
        }
      }

    }
  }
  /deep/.ant-descriptions:last-child{
    .ant-descriptions-view{
      border-bottom: none;
    }
  }
}
</style>
